import styled from 'styled-components';

import media from 'apps/auth/theme/media';
import zIndex from 'apps/auth/theme/zIndex';

interface NavBarCommonProps {
    fullwidth?: boolean;
    insideStories?: boolean;
    isNewMainScreen?: boolean;
}

interface InnerProps extends NavBarCommonProps {
    align?: 'left' | 'right' | 'space-between' | 'center';
    isSearchBar?: boolean;
}

const getJustifyContent = (props: InnerProps) => {
    if (props.isSearchBar || props.align === 'center') {
        return 'center';
    } else if (props.align === 'space-between') {
        return 'space-between';
    } else {
        return props.align === 'left' ? 'start' : 'flex-end';
    }
};

const getMobilePadding = (props: InnerProps) => {
    if (props.isSearchBar) {
        return '0';
    } else if (props.insideStories) {
        return '24px 16px 16px 16px';
    } else if (props.isNewMainScreen) {
        return '8px 16px 0 16px';
    }
    return '16px';
};

const getPadding = (props: InnerProps) => {
    if (props.fullwidth) {
        return '56px 136px';
    } else if (props.isSearchBar) {
        return '0';
    } else if (props.insideStories) {
        return '42px 16px 16px 16px';
    } else if (props.isNewMainScreen) {
        return '32px 16px 16px 16px';
    }
    return '56px 16px';
};

export const Container = styled.div<NavBarCommonProps>`
    background-color: #fff;
    left: 0;
    position: ${(props) => (props.insideStories ? 'absolute' : 'fixed')};
    right: 0;
    top: 0;
    height: 0;
    pointer-events: none;
    z-index: ${(props) => (props.isNewMainScreen ? 'auto' : zIndex.navBar)};

    ${media.desktop1224} {
        left: ${(props) => (props.fullwidth ? '360px' : null)};
    }
`;

export const Inner = styled.div<InnerProps>`
    box-sizing: border-box;
    margin: 0 auto;
    padding: ${(props) => getMobilePadding(props)};
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: ${(props) => getJustifyContent(props)};
    max-width: ${(props) => (props.isNewMainScreen ? '480px' : '528px')};

    ${media.tablet720} {
        padding: ${(props) => getPadding(props)};
        max-width: ${(props) => (props.fullwidth ? '100%' : props.isNewMainScreen ? '888px' : '568px')};
    }

    ${media.tablet1080} {
        max-width: ${(props) => (props.fullwidth ? '1080px' : props.isNewMainScreen ? '888px' : '856px')};
    }

    ${media.desktop1224} {
        margin: ${(props) => (props.fullwidth ? '0' : '0 auto')};
    }
`;
